import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Avatar, Badge, Box, Typography, withStyles } from "@material-ui/core";
import { AlternateEmail } from "@material-ui/icons";
import ReactHtmlParser from "react-html-parser";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
	formatMessageCalendarDay,
	formatMessageClock,
} from "../../helpers/dateTimeFormat";
import { useBusinessTimezone } from "../../context/BusinessTimezone/BusinessTimezoneContext";

const SmallAvatar = withStyles((theme) => ({
	root: {
		width: 22,
		height: 22,
	},
}))(Avatar);

const useStyles = makeStyles((theme) => ({
	contactAvatar: {
		width: 40,
		height: 40,
		backgroundColor: "#bdbdbd",
		borderRadius: "50%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",

		"& svg": {
			color: "#fff",
			fontSize: "2em",
		},
	},

	messageBox: {
		width: "100%",
	},

	messageCard: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		gap: "1rem",
		cursor: "pointer",
	},

	messageBody: {
		// backgroundColor: "#fff",
		// padding: "0.2rem",
		// borderRadius: "1rem",
		// maxWidth: "80%",
		// wordBreak: "break-word",
		// overflow: "hidden",
		// textOverflow: "ellipsis",
		// whiteSpace: "nowrap",
	},

	messageHeader: {
		width: "100%",
		display: "flex",
		justifyContent: "space-between",
	},

	messageSender: {
		fontWeight: "bold",
	},

	messageDate: {
		fontSize: "0.8rem",
	},
}));

const toAvatarSrc = (mod) => {
	const s = typeof mod === "string" ? mod : mod?.default ?? "";
	return typeof s === "string" ? s : "";
};

const MessageCard = ({ message, searchParam }) => {
	const { timeZone: businessTimeZone } = useBusinessTimezone();
	const classes = useStyles();
	const history = useHistory();

	const highlightBody = (messageBody) => {
		const safeBody = messageBody ?? "";
		const generalSearchParam = searchParam.toLowerCase();

		const htmlStringfied = safeBody
			.toLowerCase()
			.normalize("NFD")
			.replace(/\p{Diacritic}/gu, "")
			.replace(
				generalSearchParam,
				`<strong style="color:#088069; font-weight: 900">${generalSearchParam}</strong>`
			);

		return ReactHtmlParser(`<p style="width: 90%">${htmlStringfied}</p>`);
	};

	return (
		<div
			className={classes.messageCard}
			onClick={() => history.push(`/tickets/${message.ticketId}`)}
		>
			{message?.channel === "whatsapp" && (
				<SmallAvatar
					src={toAvatarSrc(require("../../assets/icons/whatsapp.svg"))}
					style={{ backgroundColor: "#fff" }}
				/>
			)}
			{message?.channel === "telegram" && (
				<SmallAvatar
					src={toAvatarSrc(require("../../assets/icons/telegram.svg"))}
					style={{ backgroundColor: "#fff" }}
				/>
			)}
			{message?.channel === "instagram" && (
				<SmallAvatar
					src={toAvatarSrc(require("../../assets/icons/instagram.svg"))}
					style={{ backgroundColor: "#fff" }}
				/>
			)}
			{message?.channel === "facebook" && (
				<SmallAvatar
					src={toAvatarSrc(require("../../assets/icons/facebook.svg"))}
					style={{ backgroundColor: "#fff" }}
				/>
			)}
			{message?.channel === "whatsappbusiness" && (
				<SmallAvatar
					src={toAvatarSrc(require("../../assets/icons/wppbusiness.svg"))}
					style={{ backgroundColor: "#fff" }}
				/>
			)}
			{message?.channel === "email" && (
				<AlternateEmail
					fontSize="small"
					style={{ backgroundColor: "#fff", borderRadius: "50%" }}
					color="primary"
				/>
			)}

			<div className={classes.messageBox}>
				<div className={classes.messageHeader}>
					<Typography variant="body1" className={classes.messageSender}>
						{message?.name}
					</Typography>

					<Typography variant="body2" className={classes.messageDate}>
						{/* {message?.createdAt} */}

						{/* created at from 2023-01-15T23:29:28.097Z format to brazil format */}
						{`${formatMessageCalendarDay(message?.createdAt, businessTimeZone)} ${formatMessageClock(message?.createdAt, businessTimeZone)}`}
					</Typography>
				</div>

				{/* <div className={classes.messageBody}>{message?.body}</div> */}
				{highlightBody(message.body)}
			</div>
		</div>
	);
};

export default MessageCard;
